import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface AuthState {
  user: IUser | null;
  accessToken: string | null;
  isUserLoaded: boolean;
}

const token = localStorage.getItem("accessToken");

const initialState: AuthState = {
  user: null,
  accessToken: token,
  isUserLoaded: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setUser: (state, { payload }: PayloadAction<AuthState["user"]>) => {
      state.user = payload;
      state.isUserLoaded = true;
    },
    setUserToken: (
      state,
      { payload: accessToken }: PayloadAction<AuthState["accessToken"]>
    ) => {
      state.accessToken = accessToken;
    },
    logout: (state) => {
      state.user = null;
      state.accessToken = null;
    },
  },
});

export const { setUser, setUserToken, logout } = authSlice.actions;
